import { Component, OnInit, inject } from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";

import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";

@Component({
  selector: 'app-alcohol-consumption',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    ReactiveFormsModule
],
  templateUrl: './alcohol-consumption.component.html',
  styleUrl: './alcohol-consumption.component.css'
})
export class AlcoholConsumptionComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, caption: string, value: boolean }[] = [];
  radioControl = new FormControl();

  ngOnInit(): void {
    this.options = [
      {
        headline: this.locale.currentTranslation.yes,
        caption: '',
        value: true
      },
      {
        headline: this.locale.currentTranslation.no,
        caption: '',
        value: false
      }
    ]
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.hasConsumedDrugs !== null) {
        this.radioControl = new FormControl(this.claimService.claimReport().hasConsumedDrugs);
      }
    })
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({hasConsumedDrugs: this.radioControl.getRawValue()});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['alcohol-consumption']);
      });
    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    this.showError = rawValue == null;
  }

  setOption(value: boolean) {
    this.radioControl.patchValue(value);
    this.showError = false
  }
}
